@if (showShell) {

  <div class="app-shell">

    <div

      class="nav-backdrop"

      [class.visible]="sideNavOpen"

      (click)="closeSideNav()"

      aria-hidden="true"

    ></div>



    <app-side-nav

      [isOpen]="sideNavOpen"

      (closeSideNav)="closeSideNav()"

    ></app-side-nav>



    <header class="mobile-topbar">

      <button

        type="button"

        class="menu-toggle"

        [class.active]="sideNavOpen"

        (click)="toggleSideNav()"

        [attr.aria-expanded]="sideNavOpen"

        aria-label="Toggle navigation"

      >

        <span class="bar"></span>

        <span class="bar"></span>

        <span class="bar"></span>

      </button>

      <div class="mobile-brand">
        <img src="/images/logo.png" alt="Unplugg Software Solutions" class="mobile-logo" />
        <div class="mobile-brand-text">
          <span class="mobile-brand-title">Unplugg Software Solutions</span>
          <span class="mobile-brand-sub">Inventory Management System</span>
        </div>
      </div>

    </header>

    @if (showSessionWarning()) {
      <div class="session-warning" role="alert">
        <div class="session-warning-text">
          <i class="bi bi-clock-history"></i>
          <span>
            Your session expires in about {{ sessionMinutesLeft() }} minute(s).
            Stay signed in to keep working.
          </span>
        </div>
        <div class="session-warning-actions">
          <button
            type="button"
            class="session-btn primary"
            (click)="extendSession()"
            [disabled]="sessionExtending()"
          >
            {{ sessionExtending() ? 'Extending…' : 'Stay signed in' }}
          </button>
          <button type="button" class="session-btn" (click)="dismissSessionWarning()">
            Dismiss
          </button>
        </div>
      </div>
    }

    <main class="main-content">

      <router-outlet />

    </main>

  </div>

} @else {

  <router-outlet />

}


